import { VisionaryScene } from '@/visionaryControllers/visionaryScene.ts';

/**
 * 模型视图控制器，负责管理模型视图的显示和隐藏
 * 负责管理模型视图的复制和删除
 * 负责管理模型视图的选中
 * 负责管理模型视图的列表更新
 */
export class ModelViewController {
  public sceneid: string;
  private visionaryScene: VisionaryScene;

  constructor(scene: VisionaryScene) {
    this.visionaryScene = scene;
    this.sceneid = scene.getId();
  }

  public updateModelVisibility(id: string, visible: boolean) {
    this.visionaryScene.setObjectVisibility(id, visible);
  }

  public doObjectCopy(id: string) {
    this.visionaryScene.copyObjectById(id);
  }

  public doObjectDelete(id: string) {
    this.visionaryScene.removeObjectById(id);
  }

  public doObjectSelect(id: string) { // 需要更新scene中选中的对象
    this.visionaryScene.clearSelection();
    this.visionaryScene.setObjectSelected(id, true);
  }

  public clearObjectSelect() {
    this.visionaryScene.clearSelection();
  }


  public updateModelList() {
    console.log("updateModelList");
  }
}

